import { Form as FormikForm, FormikFormProps } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { spacing04, spacing05, spacing16 } from '../../styling/spacing';
import { ButtonRow } from '../Button';
import { ErrorBox } from '../ErrorBox';

type Props = {
  disabled?: boolean;
} & FormikFormProps;

export const Form = (props: Props) => (
  <FormContext.Provider value={{ isDisabled: props.disabled }}>
    <FormikForm {...props} autoComplete="off" />
  </FormContext.Provider>
);

type FormContextValue = {
  isDisabled: boolean | undefined;
};

export const FormContext = React.createContext<FormContextValue>({
  isDisabled: undefined,
});

export const FormHeaderFieldsContainer = styled.div`
  max-width: ${spacing16};
`;

export const TopLevelThermostatContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${spacing04};

  > div {
    margin-bottom: 0;
  }

  > div:first-child {
    flex: 1;
  }
`;

export const FormButtonRow = styled(ButtonRow)`
  margin-top: ${spacing04};
`;

export const FormErrorBox = styled(ErrorBox)`
  margin-top: ${spacing05};
  margin-bottom: ${spacing05};
`;
